import React from 'react';
import { Paperclip, FileText, Eye, Download, DollarSign } from 'lucide-react';

export default function DocumentosHistorial({ 
  solicitud, 
  loadingDocOrig, 
  docOriginalUrl 
}) {
  return (
    <>
      {/* Documento original ciudadano */}
      <div className="glass-card">
        <h4 style={{ margin: '0 0 1rem', display: 'flex', alignItems: 'center', gap: 8 }}>
          <Paperclip size={18} /> Documento del Ciudadano
        </h4>
        {!solicitud.s3_path ? (
          <p className="text-muted" style={{ fontSize: '0.85rem' }}>El ciudadano no adjuntó documento.</p>
        ) : loadingDocOrig ? (
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: '0.85rem', color: 'var(--text-muted)' }}>
            <span className="spinner" style={{ width: 16, height: 16 }} /> Cargando...
          </div>
        ) : Array.isArray(docOriginalUrl) && docOriginalUrl.length > 0 ? (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            {docOriginalUrl.map((doc, idx) => (
              <div key={idx} style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                <div style={{ background: '#f0fdf4', padding: '0.7rem 0.9rem', borderRadius: 8, border: '1px solid #bbf7d0', display: 'flex', alignItems: 'center', gap: 8 }}>
                  <FileText size={16} color="var(--success)" style={{ flexShrink: 0 }} />
                  <span style={{ fontSize: '0.82rem', fontWeight: 600, flex: 1, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {doc.nombre_archivo}
                  </span>
                </div>
                <div style={{ display: 'flex', gap: 8 }}>
                  <a href={doc.url} target="_blank" rel="noreferrer"
                    className="btn btn-sm" style={{ flex: 1, textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 5, textDecoration: 'none' }}>
                    <Eye size={14} /> Ver
                  </a>
                  <a href={doc.url} download={doc.nombre_archivo}
                    className="btn btn-secondary btn-sm" style={{ flex: 1, textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 5, textDecoration: 'none' }}>
                    <Download size={14} /> Descargar
                  </a>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-muted" style={{ fontSize: '0.85rem' }}>Error al cargar documentos.</p>
        )}
      </div>

      {/* Comprobante de Pago */}
      {solicitud.comprobante_url && (
        <div className="glass-card">
          <h4 style={{ margin: '0 0 1rem', display: 'flex', alignItems: 'center', gap: 8 }}>
            <DollarSign size={18} /> Comprobante de Pago
          </h4>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
            <div style={{ background: '#e0e7ff', padding: '0.7rem 0.9rem', borderRadius: 8, border: '1px solid #c7d2fe', display: 'flex', alignItems: 'center', gap: 8 }}>
              <FileText size={16} color="var(--primary)" style={{ flexShrink: 0 }} />
              <span style={{ fontSize: '0.82rem', fontWeight: 600, flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                comprobante_pago
              </span>
            </div>
            <div style={{ display: 'flex', gap: 8 }}>
              <a href={solicitud.comprobante_url} target="_blank" rel="noreferrer"
                className="btn btn-sm" style={{ flex: 1, textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 5, textDecoration: 'none' }}>
                <Eye size={14} /> Ver
              </a>
              <a href={solicitud.comprobante_url} download="comprobante_pago"
                className="btn btn-secondary btn-sm" style={{ flex: 1, textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 5, textDecoration: 'none' }}>
                <Download size={14} /> Descargar
              </a>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
